import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Tabs } from 'antd'
import CostInvoiceCostList from './CostInvoiceCostList'
import { PlusOutlined, ScheduleOutlined, FileDoneOutlined } from '@ant-design/icons'
import CostInvoiceListSubmitted from './CostInvoiceListSubmitted'
import CostInvoiceListAll from './CostInvoiceListAll'
function CostInvoiceList(props) {
    const [key, setKey] = useState(JSON.parse(localStorage.getItem('jtg-caiwu_costInvoiceList_key') ) || '0');
    return (
        <Main selectedKeys='/CostInvoiceList' yh_qx={props.yh_qx}>
            <Tabs
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <CostInvoiceCostList 
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name} 
                                        yh_id={props.yh_id} 
                                        yh_name={props.yh_name} 
                                        ddzcList={props.ddzcList}
                                    />,
                        icon: <PlusOutlined />,
                    },
                    {
                        key: '1',
                        label: '我已提交的',
                        children: <CostInvoiceListSubmitted 
                                        qy_id={props.qy_id} 
                                        yh_id={props.yh_id} 
                                 />,
                        icon: <ScheduleOutlined />,
                    },
                    {
                        key: '2',
                        label: '所有成本票登记',
                        children: <CostInvoiceListAll 
                                        qy_id={props.qy_id} 
                                        yh_id={props.yh_id} 
                                 />,
                        icon: <FileDoneOutlined />,
                    },
                ]}
                onChange={(key) => {
                    setKey(key);
                    localStorage.setItem('jtg-caiwu_costInvoiceList_key', JSON.stringify(key));
                }}
                activeKey={key}
            />
        </Main>
    )
}

export default CostInvoiceList